import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Para qué edad es este material?',
    a: 'El MegaPack está diseñado para adolescentes de 12 a 18 años. El lenguaje, los ejemplos y las situaciones están adaptados a la realidad actual. Padres de chicos de 10-11 años también lo usan con muy buenos resultados.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el enlace de descarga de todos los PDFs. En menos de 5 minutos tenés todo el material en tu dispositivo. No hay envío físico — es 100% digital.'
  }, {
    q: '¿Lo puede usar el adolescente solo o necesita un adulto?',
    a: 'Está diseñado para ambos casos. Cada tomo tiene una sección inicial para el adulto y luego ejercicios que el adolescente puede hacer solo. Lo ideal es combinarlo — pero funciona en las dos modalidades.'
  }, {
    q: '¿Qué lo diferencia de lo que hay gratis en internet?',
    a: 'El material gratuito está fragmentado y descontextualizado. Este MegaPack es un sistema completo, secuenciado, con lenguaje propio, con protocolos de intervención reales y con herramientas diseñadas para la vida cotidiana de familias y aulas.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios, sin drama. Punto.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-53">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-800 border border-navy-700 rounded-2xl overflow-hidden transition-colors hover:border-navy-600" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-56">
                <span className="font-semibold text-lg text-white pr-8" data-id="element-57">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-blue-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" />
              </button>

              <AnimatePresence data-id="element-59">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-60">
                    <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-navy-700/50 pt-4 mt-2" data-id="element-61">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}